/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Capability_Customers_HintInputs */



/**
* | output |
* | --- |
* | "Create ordinary customer organizations. Contract customers are covered by the “Sell contracts” switch. Every partner that existed before this switch was intr..." |
*
* @param {Partner_Admin_Capability_Customers_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_capability_customers_hint = /** @type {((inputs?: Partner_Admin_Capability_Customers_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Capability_Customers_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Normale Kundenorganisationen anlegen. Vertragskunden deckt der Schalter „Verträge verkaufen“ ab. Jeder Partner, der vor Einführung dieses Schalters bestand, hat die Berechtigung bereits.")
	return /** @type {LocalizedString} */ ("Create ordinary customer organizations. Contract customers are covered by the “Sell contracts” switch. Every partner that existed before this switch was introduced already has it.")
});